var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "max-width": "1440px",
      "width": "100%"
    }
  }, [_c('dashboard-pin')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }